import listCountry from '@/static/data/countryList.json';

export const currencies = (x = '') => {
  const parts = x.toString().split('.');
  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  return parts.join(',');
};

/*
 * getValue function is get native version of Lodash
 * const object = { a: [{ b: { c: 3 } }] };
 * const result = getValue(object, 'a[0].b.c'); return 3
 * expected return empty string if get(object, 'a.b.c')
 * source: https://github.com/you-dont-need/You-Dont-Need-Lodash-Underscore#_get
 */

export const getValue = (obj, path, defaultValue = '') => {
  const travelPath = regexp =>
    String.prototype.split
      .call(path, regexp)
      .filter(Boolean)
      .reduce((res, key) => (res !== null && res !== undefined ? res[key] : res), obj);
  const result = travelPath(/[,[\]]+?/) || travelPath(/[,[\].]+?/);
  return result === undefined || result === obj ? defaultValue : result;
};

export const isSequenceNumber = (numbers = '0') => {
  const arrayOfDigits = Array.from(String(numbers), Number);
  if (arrayOfDigits.length > 1)
    return arrayOfDigits.every((num, i) => i === arrayOfDigits.length - 1 || num < arrayOfDigits[i + 1]);
  return false;
};

export const isSameValue = (data = '') => {
  const array = data.split('');
  if (array.length > 1) return array.every((item, idx, arr) => item === arr[0]);
  return false;
};

export const getPhoneCountryCode = (phone = '') => {
  const country = listCountry.find(country => {
    return phone.includes(country.phoneCode);
  });
  return country;
};
